import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../components/Button';
import { PricingCardListItem } from '../../../components/PricingCalculatorCard';
import useModal from '../../../hooks/useModal';
import ChangeHSAContributionsModal from './ChangeHSAContributionsModal';

const ChangeHSAContributionsModalDemo = () => {
  const [
    showChangeHSAContributionsModal,
    handleShowChangeHSAContributionsModal,
    handleCloseChangeHSAContributionsModal,
  ] = useModal();

  const [prePayItems, setPrePayItems] = React.useState<
    Array<PricingCardListItem>
  >([
    {
      text: 'Your New Contributions (Future)',
      value: 500,
    },
    {
      text: 'Company Contributions (Future)',
      value: 115.38,
    },
    {
      text: 'Total Contributions (YTD)',
      value: 2034.62,
    },
  ]);

  const [oneTimeItems, setOneTimeItems] = React.useState<
    Array<PricingCardListItem>
  >([
    {
      text: 'Your New One-Time Contributions',
      value: 100,
    },
    {
      text: 'Your New One-Time Contributions',
      value: 150,
    },
    {
      text: 'Company Contributions (Future)',
      value: 115.38,
    },
    {
      text: 'Total Contributions (YTD)',
      value: 2034.62,
    },
  ]);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Change HSA Contributions Modal</h4>
        <Button onMouseDown={handleShowChangeHSAContributionsModal}>
          Open Modal
        </Button>
        <ChangeHSAContributionsModal
          showChangeHSAContributionsModal={showChangeHSAContributionsModal}
          prePayItems={prePayItems}
          oneTimeItems={oneTimeItems}
          setOneTimeItems={setOneTimeItems}
          setPrePayItems={setPrePayItems}
          handleCloseChangeHSAContributionsModal={
            handleCloseChangeHSAContributionsModal
          }
        />
      </Container>
    </Container>
  );
};

export default ChangeHSAContributionsModalDemo;
